export default function ContainerGrid({ className = '', children, itemWidth = '350px' }) {
    return (
        <div className={`container-grid ${className}`} style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(${itemWidth}, 1fr))`
        }}>
            { children }
        </div>
    )
}